import { AutoExportFormatterConfigurationIseMeteringIdentificationType } from './autoexport-formatter-configuration-ise-meteringidentification-type.model';

export class AutoExportFormatterConfigurationIseMeteringIdentificationTypeItem {
    constructor(
        meteringIdentificationType: AutoExportFormatterConfigurationIseMeteringIdentificationType,
        meteringIdentificationTypeText: string) {
        this.meteringIdentificationType = meteringIdentificationType;
        this.meteringIdentificationTypeText = meteringIdentificationTypeText;
    }

    meteringIdentificationType: AutoExportFormatterConfigurationIseMeteringIdentificationType;
    meteringIdentificationTypeText: string;
}
